import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f7b1ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row w-100 q-mb-md items-center justify-center" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "row w-100 items-center q-gutter-y-md" }
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md text-center third" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "text-p text-gray-primary q-mx-md-none q-mx-xs-auto" }
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-auto first" }
const _hoisted_10 = { class: "row full-width justify-xs-center justify-md-end items-center" }
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md second" }
const _hoisted_12 = { class: "row justify-xs-center justify-md-end" }

import dataTestIds from 'app/cypress/e2e/dataTestIds';
import AppIcon from 'assets/AppIcon.vue';
import AddExtensionButton from 'components/@common/AddExtensionButton.vue';
import useExtensionProps from 'src/composables/extensionProps';
import { getRoutePath, ROUTES } from 'src/router/routes';
import { useUserStore } from 'src/store/userStore';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageFooter',
  emits: ['scroll'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const { androidButtonData, iosButtonData } = useExtensionProps();
const emit = __emit;
const user = useUserStore();

const socialLints = [
  { icon: 'facebook', href: 'https://www.facebook.com/getcheerie' },
];

let footerLinks = ref([
  {
    name: t('about'),
    routeName: ROUTES.ABOUT,
    dataTestId: dataTestIds.FOOTER.ABOUT,
  },
  {
    name: `${t('homePage.howToTitle')}?`,
    action: () => emit('scroll', ROUTES.HOW_IT_WORKS),
    dataTestId: dataTestIds.FOOTER.HOW_IT_WORKS,
  },
  {
    name: t('donationReports'),
    routeName: ROUTES.DONATION,
    dataTestId: dataTestIds.FOOTER.DONATION,
  },
  {
    name: t('privacy'),
    routeName: ROUTES.PRIVACY,
    dataTestId: dataTestIds.FOOTER.PRIVACY,
  },
  {
    name: t('terms'),
    routeName: ROUTES.TERMS,
    dataTestId: dataTestIds.FOOTER.TERMS,
  },
]);

const isUserLoggedIn = computed(() => {
  return user.isLoggedIn;
});

watch(
  isUserLoggedIn,
  () => {
    if (isUserLoggedIn.value) {
      footerLinks.value.push({
        name: t('deleteAccount'),
        routeName: ROUTES.DELETE_ACCOUNT,
        dataTestId: dataTestIds.FOOTER.deleteAccount,
      });
    } else {
      footerLinks.value = footerLinks.value.filter(
        (link) => link.routeName !== ROUTES.DELETE_ACCOUNT
      );
    }
  },
  { immediate: true }
);

const currentYear = computed(() => {
  return new Date().getFullYear();
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    "enter-active-class": "animated fadeIn",
    "leave-active-class": "animated fadeOut"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, { class: "footer-wrapper q-px-lg q-py-md flex column" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footerLinks), (link) => {
              return (_openBlock(), _createElementBlock("div", {
                key: link,
                "data-testid": link.dataTestId,
                class: "forward-on-hover footer-link"
              }, [
                _createElementVNode("h6", {
                  class: "cursor-pointer text-capitalize",
                  onClick: _withModifiers(($event: any) => (
              link?.action
                ? link.action()
                : _ctx.$router.push({ name: link.routeName })
            ), ["prevent"])
                }, [
                  _createElementVNode("a", {
                    href: _unref(getRoutePath)(link.routeName)
                  }, _toDisplayString(link.name), 9, _hoisted_4)
                ], 8, _hoisted_3)
              ], 8, _hoisted_2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, " © " + _toDisplayString(currentYear.value) + " Cheerie. " + _toDisplayString(_ctx.$t('allRightsReserved')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_q_btn, {
                  "data-testid": _unref(dataTestIds).FOOTER.IOS_BUTTON,
                  href: _unref(iosButtonData).link,
                  class: "q-mr-40 hvr-grow-rotate",
                  flat: "",
                  unelevated: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppIcon, {
                      name: "download-app-store",
                      width: 138,
                      height: 40
                    })
                  ]),
                  _: 1
                }, 8, ["data-testid", "href"]),
                _createVNode(AddExtensionButton, {
                  class: "q-mr-40 desktop-only",
                  style: {"min-height":"40px !important"}
                }),
                _createVNode(_component_q_btn, {
                  "data-testid": _unref(dataTestIds).FOOTER.ANDROID_BUTTON,
                  href: _unref(androidButtonData).link,
                  class: "q-mr-40 hvr-grow-rotate",
                  flat: "",
                  unelevated: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppIcon, {
                      name: "download-google-play",
                      width: 138,
                      height: 40
                    })
                  ]),
                  _: 1
                }, 8, ["data-testid", "href"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialLints, (social) => {
                  return _createVNode(_component_q_btn, {
                    key: social,
                    href: social.href,
                    target: "_blank",
                    flat: "",
                    unelevated: "",
                    class: "social-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "social",
                        name: social.icon,
                        width: 24,
                        height: 28
                      }, null, 8, ["name"])
                    ]),
                    _: 2
                  }, 1032, ["href"])
                }), 64))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})